import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CustomerSurveyComponent } from './components/customer-survey/customer-survey.component';
import { AuthGuard } from '../../auth/auth.guard';

const routes: Routes = [
  // {
  //   path: 'stratus-setup/:id',
  //   component: CustomerSurveyComponent,
  //   canActivate: [AuthGuard],
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerSurveyRoutingModule { }
